import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
} from "@angular/core"
import { Observable, Subscription } from "rxjs"
import { LearningObject } from "../../../models/learningObject.model"
import { WindowSizeService } from "../../../services/window-size.service"
import { PreviewService } from "../../../services/preview.service"

@Component({
    selector: "app-resources-section",
    templateUrl: "./resources-section.component.html",
    styleUrls: ["./resources-section.component.scss"],
    standalone: false,
})
export class ResourcesSectionComponent implements OnChanges, OnInit {
    @Input() public resources: LearningObject[][]
    @Input() public start: number = 0
    @Input() public stop: number = 0
    @Input() public page: number = null
    @Output() public loaded: EventEmitter<boolean> = new EventEmitter<boolean>()
    isLoading: boolean = true
    isInPreviewMode: boolean = false
    public subs: Subscription[] = []

    constructor(
        public windowSize: WindowSizeService,
        private cdRef: ChangeDetectorRef,
        private previewService: PreviewService
    ) {}

    ngOnInit(): void {
        this.isInPreviewMode =
            this.previewService.previewOnCollection || this.previewService.previewOnSubCollection
    }

    public getResources(): any[] {
        if (this.page != null) {
            return this.resources[this.page]
        } else {
            return [].concat(...this.resources).slice(this.start, this.stop)
        }
    }

    ngOnChanges(): void {
        this.hadResourcesLoaded()
        this.cdRef.detectChanges()
    }

    public hadResourcesLoaded(): void {
        this.isLoading = !this.resources.length
        if (!this.isLoading) this.loaded.emit(false)
    }
}
